import React from "react";
import {
  SummaryCard,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  TrendingUpSummaryValue,
  TrendingDownSummaryValue,
  MediumSummaryValue,
  SummaryItemEnd,
} from "./styles";
import { TrendingItemsSummaryProps } from "./types";

const TrendingItemsSummary: React.FC<TrendingItemsSummaryProps> = ({
  summary,
}) => {
  return (
    <SummaryCard>
      <SummaryGrid>
        <SummaryItem>
          <SummaryLabel>Trending Up</SummaryLabel>
          <TrendingUpSummaryValue>
            {summary?.trendingUp || 0}
          </TrendingUpSummaryValue>
        </SummaryItem>
        <SummaryItemEnd>
          <SummaryLabel>Trending Down</SummaryLabel>
          <TrendingDownSummaryValue>
            {summary?.trendingDown || 0}
          </TrendingDownSummaryValue>
        </SummaryItemEnd>
        <SummaryItem>
          <SummaryLabel>Stable Items</SummaryLabel>
          <MediumSummaryValue>{summary?.stable || 0}</MediumSummaryValue>
        </SummaryItem>
        <SummaryItemEnd>
          <SummaryLabel>Total Trending</SummaryLabel>
          <MediumSummaryValue>
            {(summary?.trendingUp || 0) + (summary?.trendingDown || 0) + (summary?.stable || 0)}
          </MediumSummaryValue>
        </SummaryItemEnd>
      </SummaryGrid>
    </SummaryCard>
  );
};

export default TrendingItemsSummary;
